import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
    computed: {
        mask() {
            return {
                valor: createNumberMask({
                    allowDecimal: true,
                    allowNegative: false,
                    decimalLimit: 2,
                    decimalSymbol: ',',
                    includeThousandsSeparator: true,
                    prefix: '',
                    thousandsSeparatorSymbol: '.',
                }),
                phone: '(##) ####-####',
                cellPhone: '(##) #####-####',
                cep: '##.###-###',
                cpf: '###.###.###-##',
                cns: '### #### #### ####',
                cnpj: 'NN.NNN.NNN/NNNN-##',
                rg: '##.###.###-##',
                numeroCertidao: '###### ## ## #### # ##### ### ####### ##',
                numeroAutorizacaoFornecimento: '#####/####',
                numeroPlacaPadraoDetran: 'AAA-####',
                numeroPlacaPadraoMercosul: 'AAA-#A##',
                dnv: '##-########-#'
            }
        }
    }
}